import {React, useState} from 'react';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {Grid, Box, Button, Paper,createTheme, ThemeProvider, Typography} from '@mui/material';
import {PriceChange, Business, ManageAccounts, CalendarMonth, Addchart, Houseboat, ImportExport, PriceCheck, RequestQuote, VpnKey} from '@mui/icons-material';
function handleClick(event){
  alert(event.currentTarget.id)
}

function CompanyMasters(){

  const [values, setValues] = useState();
  const [openPopup, setOpenPopup] = useState(false);
  const isAdmin = useSelector((state) => state.auth.activeUserRole) === 'ADMIN';

  const theme = createTheme({
    palette: {
      primary: { main: '#0b418e' },
      danger: {
        main: '#ffeb3b',
      },
      orange: {
        main: '#ff5722',
      },
      blueGrey: {
        main: '#607d8b',
      },
      lightGreen: {
        main: '#689f38',
      },
      pink: {
        main: '#ec407a',
      },
      purple: {
        main: '#ab47bc',
      },
      deepPurple: {
          main: '#7e57c2',
      },
      amber: {
        main: '#ffca28'
      },
      lime: {
        main: '#c0ca33'
      },
      brown: {
        main: '#8d6e63'
      }
    },
  });

  return(
    <ThemeProvider theme={theme}>
    <Box className="master-button-container">
      <Paper  className="paper-container" levation={5} sx={{width: "1000px", padding: "30px"}}>
      <Typography variant="h4" sx={{textAlign: "center", marginBottom: "20px"}}>Masters</Typography>
          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
              <Link to="company-definition-form" className="link">
                <Button id="btn1" sx={{color: "white"}} className="master-btn" variant="contained" color="deepPurple" startIcon={<Business sx={{width: "30px", height: "30px"}}/>} >
                Company Master
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="salary-parameters-form" className="link">
                <Button id="btn2" sx={{color: "white"}} className="master-btn" variant="contained" color="lightGreen" startIcon={<PriceChange sx={{width: "30px", height: "30px"}}/>}>
                Salary Parameters
                </Button>
              </Link>
            </Grid>
          </Grid>
          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
                <Button id="btn3" sx={{color: "white"}} className="master-btn" variant="contained" color="blueGrey" startIcon={<PriceCheck sx={{width: "30px", height: "30px"}}/>}>
                Income Tax Rules
                </Button>
            </Grid>
            <Grid item>
                <Button id="btn4" sx={{color: "white"}} className="master-btn" variant="contained" color="brown" startIcon={<RequestQuote sx={{width: "30px", height: "30px"}}/>}>
                Income Tax Slabs
                </Button>
            </Grid>
          </Grid>
          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
              <Link to="insert-header" className="link">
                <Button id="btn5" sx={{color: "white"}} className="master-btn" variant="contained" color="success" startIcon={<Addchart sx={{width: "30px", height: "30px"}}/>}>
                Insert Header
                </Button>
              </Link>
            </Grid>
            {isAdmin && (
            <Grid item>
              <Link to="user-management" className="link">
                <Button id="btn6" sx={{color: "white"}} className="master-btn" variant="contained" color="orange" startIcon={<ManageAccounts sx={{width: "30px", height: "30px"}}/>}>
                User Management
                </Button>
              </Link>
            </Grid>
            )}
            <Grid item>
              <Link to="api-keys" className="link">
                <Button id="btn-api-keys" sx={{color: "white"}} className="master-btn" variant="contained" color="deepPurple" startIcon={<VpnKey sx={{width: "30px", height: "30px"}}/>}>
                API Keys
                </Button>
              </Link>
            </Grid>
          </Grid>
          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
              <Link to="leave-master-form" className="link">
                <Button id="btn7" sx={{color: "white"}} className="master-btn" variant="contained" color="error" startIcon={<CalendarMonth sx={{width: "30px", height: "30px"}}/>}>
                Leave Master
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="holiday-master-form" className="link">
                <Button id="btn8" sx={{color: "white"}} className="master-btn" variant="contained" color="pink" startIcon={<Houseboat sx={{width: "30px", height: "30px"}}/>}>
                Holiday Master
                </Button>
              </Link>
            </Grid>
          </Grid>
          <Grid container className="master-button-row-last" spacing={2}>
            <Grid item>
              <Link to="data-manager" className="link">
                <Button id="btn9" sx={{color: "white"}} className="master-btn" variant="contained" startIcon={<ImportExport />} >
                  Data Import/Export
                </Button>
              </Link>
            </Grid>
          </Grid>


      </Paper>
    </Box>
    </ThemeProvider>
  )
}

export default CompanyMasters;
